"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncWalkBuilder = exports.WalkBuilder = void 0;
const walk_1 = require("./walk");
class CallbacksBuilder {
    constructor(cbs, source) {
        this.cbs = cbs;
        this.source = source;
        this.callback = {
            callback: (() => { })
        };
    }
    withExecutionOrder(order) {
        this.callback.executionOrder = order;
        return this;
    }
    withFilter(fn) {
        return this.withFilters(fn);
    }
    withFilters(...fn) {
        this.callback.filters = fn;
        return this;
    }
    filteredByNodeTypes(...types) {
        this.callback.nodeTypeFilters = types;
        return this;
    }
    filteredByKeys(...keys) {
        this.callback.keyFilters = keys;
        return this;
    }
    filteredByPosition(position) {
        this.callback.positionFilter = position;
        return this;
    }
    done() {
        return this.source.withCallbacks(...this.cbs.map(cb => (Object.assign(Object.assign({}, this.callback), { callback: cb }))));
    }
}
class BaseWalkBuilder {
    constructor() {
        this._config = {};
        this.globalFilters = [];
    }
    resetConfig() {
        this._config = {};
        return this;
    }
    withConfig(config) {
        this._config = Object.assign(Object.assign({}, this._config), config);
        return this;
    }
    withTraversalMode(traversalMode) {
        this._config.traversalMode = traversalMode;
        return this;
    }
    withGraphMode(graphMode) {
        this._config.graphMode = graphMode;
        return this;
    }
    withRootObjectCallbacks(val) {
        this._config.rootObjectCallbacks = val;
        return this;
    }
    withRunningCallbacks(val) {
        this._config.runCallbacks = val;
        return this;
    }
    withConfiguredCallbacks(...callbacks) {
        return new CallbacksBuilder(callbacks, this);
    }
    withConfiguredCallback(callback) {
        return this.withConfiguredCallbacks(callback);
    }
    withCallback(callback) {
        return this.withCallbacks(callback);
    }
    withGlobalFilter(fn) {
        this.globalFilters.push(fn);
        return this;
    }
    withCallbacks(...callbacks) {
        if (!this._config.callbacks)
            this._config.callbacks = [];
        this._config.callbacks.push(...callbacks);
        return this;
    }
    getCurrentConfig() {
        var _a;
        return Object.assign(Object.assign({}, this._config), { callbacks: (_a = this._config.callbacks) === null || _a === void 0 ? void 0 : _a.map(cb => (Object.assign(Object.assign({}, cb), { filters: [
                    ...(!cb.filters ? []
                        : Array.isArray(cb.filters)
                            ? cb.filters
                            : [cb.filters]),
                    ...this.globalFilters
                ] }))) });
    }
}
class WalkBuilder extends BaseWalkBuilder {
    walk(target) {
        walk_1.walk(target, this.getCurrentConfig());
    }
    *walkStep(target) {
        return walk_1.walkStep(target, this.getCurrentConfig());
    }
    withSimpleCallback(callback) {
        return this.withSimpleCallbacks(callback);
    }
    withSimpleCallbacks(...callbacks) {
        return this.withCallbacks(...(callbacks.map(c => ({ callback: c }))));
    }
}
exports.WalkBuilder = WalkBuilder;
class AsyncWalkBuilder extends BaseWalkBuilder {
    walk(target) {
        return __awaiter(this, void 0, void 0, function* () {
            return walk_1.walkAsync(target, this.getCurrentConfig());
        });
    }
    walkStep(target) {
        return __asyncGenerator(this, arguments, function* walkStep_1() {
            return yield __await(walk_1.walkAsyncStep(target, this.getCurrentConfig()));
        });
    }
    withParallelizeAsyncCallbacks(val) {
        this._config.parallelizeAsyncCallbacks = val;
        return this;
    }
    withSimpleCallback(callback) {
        return this.withSimpleCallbacks(callback);
    }
    withSimpleCallbacks(...callbacks) {
        return this.withCallbacks(...(callbacks.map(c => ({ callback: c }))));
    }
}
exports.AsyncWalkBuilder = AsyncWalkBuilder;
